import { render } from "./index-view.vue?vue&type=template&id=2ef80260&scoped=true"
const script = {}

import "./index-view.vue?vue&type=style&index=0&id=2ef80260&lang=scss&scoped=true"

import exportComponent from "/Users/macmini/builds/VJ28wZh6/0/terracycle/tc-mini-site-frontend/node_modules/.pnpm/vue-loader@17.0.0_webpack@5.69.1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ef80260"]])

export default __exports__